import { toast } from 'react-toastify';

import { all, takeLatest, call, put } from 'redux-saga/effects';

import api from '~/services/api';

import { getDynamicTableSuccess, getDynamicTableFailure } from './actions';
import { IDynamicTableRequestAction, IDynamicTableTypes } from './types';

export function* getDynamicTable({
  payload,
}: IDynamicTableRequestAction): unknown {
  const { name, orgId } = payload;

  try {
    const response = yield call(api.get, `/dynamic-table`, {
      params: { name, orgId },
    });
    const dynamicTable = JSON.parse(response.data);

    yield put(getDynamicTableSuccess(dynamicTable));
  } catch (err) {
    yield put(getDynamicTableFailure());
    toast.error('Erro ao buscar tabela dinamica.');
  }
}

export default all([
  takeLatest(IDynamicTableTypes.DYNAMIC_TABLE_REQUEST, getDynamicTable),
]);
